import React from 'react'
import EditPolicy from '../../../../../../../component/edit-policy/index'

const ExpensePolicyEdit = () => {
  return (
    <EditPolicy type="TRIP"/>
  )
}

export default ExpensePolicyEdit